import React from 'react';

import styles from './styles.css';

const TextBlock = ({ image, copy }) => (
  <div className={styles.container}>
    <div className={styles.grid} dangerouslySetInnerHTML={{ __html: copy }} />
    <img src={image} alt={'Prick Predictor'} className={styles.image} />
  </div>
);

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/TextBlock/index.js